var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03125 0.5V4.25C3.03125 4.38906 3.09313 4.52094 3.2 4.61L5.95 6.90156L7.7 8.36C7.78687 8.4325 7.89344 8.46875 8 8.46875C8.10656 8.46875 8.21313 8.4325 8.3 8.36L10.05 6.90156L12.8 4.61C12.9069 4.52094 12.9688 4.38906 12.9688 4.25V0.5H3.03125Z",
    fill: "#48BBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 0.5V4.25C12.9688 4.38906 12.9069 4.52094 12.8 4.61L10.05 6.90156L8.3 8.36C8.21313 8.4325 8.10656 8.46875 8 8.46875V0.5H12.9688Z",
    fill: "#1293DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78125 0.5V6.54156C5.78125 6.68062 5.84312 6.8125 5.95 6.90156L7.7 8.36C7.78687 8.4325 7.89344 8.46875 8 8.46875C8.10656 8.46875 8.21313 8.4325 8.3 8.36L10.05 6.90156C10.1569 6.8125 10.2188 6.68062 10.2188 6.54156V0.5H5.78125Z",
    fill: "#84FFAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 0.5V6.54156C10.2188 6.68062 10.1569 6.8125 10.05 6.90156L8.3 8.36C8.21313 8.4325 8.10656 8.46875 8 8.46875V0.5H10.2188Z",
    fill: "#28DD7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 0.46875C13.9688 0.7275 13.7587 0.9375 13.5 0.9375H2.5C2.24125 0.9375 2.03125 0.7275 2.03125 0.46875C2.03125 0.21 2.24125 0 2.5 0H13.5C13.7587 0 13.9688 0.21 13.9688 0.46875Z",
    fill: "#596C76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 0.46875C13.9688 0.7275 13.7587 0.9375 13.5 0.9375H8V0H13.5C13.7587 0 13.9688 0.21 13.9688 0.46875Z",
    fill: "#3E4F55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5C4.82938 4.5 2.25 7.07938 2.25 10.25C2.25 13.4206 4.82938 16 8 16C11.1706 16 13.75 13.4206 13.75 10.25C13.75 7.07938 11.1706 4.5 8 4.5Z",
    fill: "#F67E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.25C13.75 13.4206 11.1706 16 8 16V4.5C11.1706 4.5 13.75 7.07938 13.75 10.25Z",
    fill: "#D06A00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.28125C5.81156 6.28125 4.03125 8.06156 4.03125 10.25C4.03125 12.4384 5.81156 14.2188 8 14.2188C10.1884 14.2188 11.9688 12.4384 11.9688 10.25C11.9688 8.06156 10.1884 6.28125 8 6.28125Z",
    fill: "#FF9E00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 10.25C11.9688 12.4384 10.1884 14.2188 8 14.2188V6.28125C10.1884 6.28125 11.9688 8.06156 11.9688 10.25Z",
    fill: "#F67E00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(4.5,6.7) scale(0.44)",
    d: "M8 1.5L9.755 5.756L14.4 6.18L10.7 9.44L11.755 14L8 11.6L4.245 14L5.3 9.44L1.6 6.18L6.245 5.756L8 1.5Z",
    fill: "#F67E00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(4.5,6.7) scale(0.44)",
    d: "M8 1.5L9.755 5.756L14.4 6.18L10.7 9.44L11.755 14L8 11.6V1.5Z",
    fill: "#D06A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipationIcon);
export default __webpack_public_path__ + "static/media/participation-icon.3fcbb941334d92b847c8fd07c15b4dc6.svg";
export { ForwardRef as ReactComponent };